/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Aggregated grading counts for one lecturer in one calendar month.
 */
export interface GradingStatsRow {
  lecturerId: string;
  lecturerName: string;
  /** Calendar month in YYYY-MM format */
  month: string;
  total: number;
  withOralExam: number;
  withoutOralExam: number;
}
